module.exports = __webpack_public_path__ + "img/calib.55d2363b.svg";